import React from "react";
import { useTranslation } from "react-i18next";

interface BetaWarningProps {
  title?: string;
  description?: string;
  className?: string;
}

const BetaWarning: React.FC<BetaWarningProps> = ({ 
  title, 
  description, 
  className = "" 
}) => {
  const { t } = useTranslation();

  const defaultTitle = title || t("beta.warning.title", "Beta Feature");
  const defaultDescription = description || t("beta.warning.description", "This feature is currently in beta and may have limited functionality or unexpected behavior.");

  return (
    <div className={`p-3 bg-orange-50 rounded-md border border-orange-200 ${className}`}>
      <div className="flex items-start space-x-2">
        <div className="text-orange-500 mt-0.5 flex-shrink-0">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-orange-800 mb-1">
            {defaultTitle}
          </p>
          <p className="text-sm text-orange-700">
            {defaultDescription}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BetaWarning; 